import { defaultBooleanValue } from '@/_schemas/generic';

import { defaultDeliveryMethod } from '../components/delivery-method';
import { defaultRemovalCause } from '../components/removal-cause';
import { defaultStatus } from '../components/status';
import type { PickTicketsFormSchema } from '../schemas';

export const defaultValues: Readonly<PickTicketsFormSchema> = {
  id: -1,
  pick_number: -1,
  client: null,
  contacts: null,

  picker_id: null,
  picker: null,
  picker_type: null,

  status: defaultStatus,
  delivery_method: defaultDeliveryMethod,
  tracking_number: '',

  remove_items: defaultBooleanValue(),
  why_removed_comment: '',
  why_removed: defaultRemovalCause,

  delivery_address: [],
  notes: '',
  attached_documents: [],
  pick_ticket_items: [],
};
